import { ReactNode } from "react";
import { Node } from "@iventis/domain-model/model/node";
import { OverflowOption } from "../../../types/data-types";
import { FlatNode } from "../../../helpers/virtual-scrolling-helpers";

export type FlatLibraryNode = FlatNode<FlatLibraryNode> & Node;

export type LibraryNodeProps = {
    preview: ReactNode;
    node: FlatLibraryNode;
    text: { emptyMessage: string; screenReaderOverflowMessage: string };
    setFavourite?: (favourite: boolean) => void;
    content?: ReactNode;
    open?: () => void;
    overflowOptions?: OverflowOption<FlatLibraryNode>[];
    disableActions?: boolean;
    expandable?: boolean;
    disabled?: boolean;
    selectable?: { disabled: boolean; tooltip?: string };
    draggingNode?: boolean;
    nodeText?: string;
    isDragging: boolean;
    subtitle?: ReactNode;
    isNameClickable: boolean;
    nodeIdsToEdit?: string[];
};
